module.exports = "<app-editor [previewMode]=true></app-editor>"